export default [
    {
        path: "/",
        meta: {
            requiresAuth: true,
            role: "admin",
            layout: "AdminLayout",
        },
        children: [
            {
                path: "admin-survey-data-select",
                name: "admin-survey-data-select",
                component: () =>
                    import("@/Pages/AdminSurvey/SelectSubModule.vue"),
                meta: { title: "Select Survey Data Type" },
            },
            {
                path: "admin-survey-dashboard",
                component: () => import("@/Pages/AdminSurvey/SurveyData/Index.vue"),
                meta: {
                    requiresAuth: true,
                    role: "admin",
                    layout: "AdminLayout",
                },
                children: [
                    {
                        path: "",
                        name: "admin-survey-dashboard",
                        component: () =>
                            import("@/Pages/AdminSurvey/Dashboard.vue"),
                        meta: { title: "Dashboard" },
                    },
                ],
            },
            {
                path: "admin-survey-data",
                component: () => import("@/Pages/AdminSurvey/SurveyData/Index.vue"),
                meta: {
                    requiresAuth: true,
                    role: "admin",
                    layout: "AdminLayout",
                },
                children: [
                    {
                        path: "",
                        name: "admin-survey-data",
                        component: () =>
                            import("@/Pages/AdminSurvey/SurveyData/List.vue"),
                        meta: { title: "Survey Data" },
                    },
                    {
                        path: "show/:id",
                        name: "admin-survey-data-show",
                        component: () =>
                            import("@/Pages/AdminSurvey/SurveyData/Show.vue"),
                        meta: { title: "Survey Data Detail" },
                    },
                    {
                        path: "edit/:id",
                        name: "admin-survey-data-edit",
                        component: () =>
                            import("@/Pages/AdminSurvey/SurveyData/Edit.vue"),
                        meta: { title: "Survey Data Detail" },
                    },
                ],
            },
            {
                path: "admin-survey-questionnaire",
                component: () =>
                    import("@/Pages/AdminSurvey/Questionnaire/Index.vue"),
                meta: {
                    requiresAuth: true,
                    role: "admin",
                    layout: "AdminLayout",
                },
                children: [
                    {
                        path: "",
                        name: "admin-survey-questionnaire",
                        component: () =>
                            import(
                                "@/Pages/AdminSurvey/Questionnaire/List.vue"
                            ),
                        meta: { title: "Questionnaire Data" },
                    },
                    {
                        path: "show/:code",
                        name: "admin-survey-questionnaire-show",
                        component: () =>
                            import(
                                "@/Pages/AdminSurvey/Questionnaire/Show.vue"
                            ),
                        meta: { title: "Questionnaire Data Detail" },
                    },
                ],
            },
        ],
    },
];
